// extracted by mini-css-extract-plugin
module.exports = {"message":"message_message__4BRat","info":"message_info__3Q0dT"};